import script from "./SignupVendorPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupVendorPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignupVendorPage.vue?vue&type=style&index=0&id=ba84c3b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba84c3b2"]])

export default __exports__